/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {startWebAuthnRegistration} from '../api'

export const useMutationStartWebAuthnRegistration = createReactQueryMutationHook('startWebAuthnRegistration', startWebAuthnRegistration)
